import { PeriodTypes, PeriodTypesLabels } from '@/models/catalog/offer';

export const periodTypesLabels = {
  [PeriodTypes.Morning]: PeriodTypesLabels.Morning,
  [PeriodTypes.Afternoon]: PeriodTypesLabels.Afternoon,
  [PeriodTypes.Evening]: PeriodTypesLabels.Evening,
  [PeriodTypes.FullTime]: PeriodTypesLabels.FullTime,
  [PeriodTypes.UponRequest]: PeriodTypesLabels.UponRequest,
  [PeriodTypes.Flex]: PeriodTypesLabels.Flex,
};
